<template lang='pug'>
  i.svg-icon.svg-icon-kind
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      
      path(d='M95.087,47.43c-0.777,3.288-1.187,6.718-2.397,9.838 c-4.696,12.099-13.77,19.716-25.742,24.078c-7.629,2.78-15.521,3.4-23.563,2.372c-0.558-0.07-1.246,0.148-1.744,0.447 c-6.174,3.707-12.322,7.456-18.484,11.183c-0.404,0.245-0.868,0.391-1.304,0.583c-0.05-0.482-0.143-0.965-0.144-1.447 c-0.01-5.759-0.061-11.518,0.031-17.275c0.023-1.506-0.428-2.436-1.615-3.388C12.884,68.017,7.917,60.695,6.21,51.48 c-2.205-11.908,1.066-22.374,9.153-31.254c7.84-8.61,17.805-13.199,29.308-14.427C57.794,4.398,69.793,7.41,80.26,15.601 C88.047,21.696,93,29.608,94.632,39.465c0.153,0.931,0.303,1.863,0.455,2.795C95.087,43.984,95.087,45.707,95.087,47.43z M30.262,74.791c0,1.959,0.042,3.32-0.014,4.679c-0.044,1.061,0.256,1.15,1.115,0.622c2.854-1.757,5.724-3.489,8.623-5.169 c0.495-0.287,1.204-0.465,1.752-0.361c4.026,0.759,8.059,1.09,12.158,0.716c8.557-0.778,16.184-3.747,22.621-9.504 c12.818-11.463,13.083-29.537,0.587-41.363c-6.427-6.083-14.19-9.265-22.945-10.018c-11.565-0.994-21.977,1.932-30.56,9.935 c-7.414,6.914-10.749,15.48-8.792,25.651c1.438,7.464,5.548,13.413,11.718,17.675C29.485,69.698,31.347,71.675,30.262,74.791z')
      
      path(d='M66.351,35.139c0,3.81-3.043,7.773-9.127,11.891c-2.163,1.424-3.496,2.424-3.998,3.001 c-1.157,1.116-1.734,2.444-1.734,3.983v2.366h-9.504v-3.925c0-1.885,1.231-3.963,3.696-6.234c2.363-1.847,4.677-3.713,6.939-5.599 c2.515-2.155,3.771-3.944,3.771-5.368c0-1.577-0.78-2.713-2.338-3.405c-1.56-0.615-4.048-0.924-7.467-0.924 c-1.861,0-5.431,0.52-10.711,1.559v-7.619c4.022-0.846,7.996-1.27,11.917-1.27c5.28,0,9.554,0.886,12.823,2.655 C64.438,28.29,66.351,31.252,66.351,35.139z M52.321,68.271H41.384v-8.312h10.938V68.271z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>